import { ProgrammaticDialog } from '@maxsystems/ui/elements'

import ShareDialog from './ShareDialog'

export default ProgrammaticDialog(ShareDialog)
